import app from '#app/app'
import { config } from '#app/config'
import { appLayout } from '#app/init_app_layout.svelte.ts'
import { API } from '#app/lib/api/api'
import preq from '#app/lib/preq'
import { addRoutes } from '#app/lib/router'
import { commands } from '#app/radio'
import type { ActivityActor } from '#server/types/activity'
import type { UserAccountUri } from '#server/types/server'
import { i18n } from '#user/lib/i18n'

export default {
  initialize () {
    addRoutes({
      '/activities(/)(:id)(/)': 'showActivity',
    }, controller)
  },
}

export interface SerializedActivityActor extends ActivityActor {
  handle: `@${UserAccountUri}`
}

const controller = {
  async showActivity (id: string) {
    try {
      const object = await preq.get(API.activitypub.activityById(id))
      const objectId = new URL(object.id).searchParams.get('id')
      const actorUrl = object.actor
      const actor = await preq.get(actorUrl) as SerializedActivityActor
      actor.handle = `@${actor.preferredUsername}@${config.publicHost}`
      const { default: Activity } = await import('./components/activity.svelte')
      appLayout.showChildComponent('main', Activity, { props: { actor, object } })
      app.navigate(`activities/${objectId}`, {
        metadata: {
          title: `${i18n('Activity')} - ${actor.name} (${actor.handle})`,
        },
      })
    } catch (err) {
      commands.execute('show:error', err)
    }
  },
} as const
